import { Cancel as CancelIcon, Check as CheckIcon } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import DatePicker from "../../../components/datePicker/DatePicker";
import dayjs, { ISO_DATE_FORMAT } from "../../../dayjs";
import type { Package } from "../../../sharedComponents/packages/PackageSelect";
import PackageSelect from "../../../sharedComponents/packages/PackageSelect";

export interface PackageProduct {
  readonly id: string;
  readonly daysShift: number;
  readonly options: string[];
}

interface Props {
  readonly disabled?: boolean;
  readonly onAdd: (
    packageIdproducts: PackageProduct[],
    startDate: string,
    tags: { readonly category: string; readonly value: string }[],
  ) => void;
}

const AddPackageProducts: FC<Props> = ({ disabled, onAdd }) => {
  const [selectMode, setSelectMode] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<Package>();
  const [startDate, setStartDate] = useState(dayjs().add(1, "day").format(ISO_DATE_FORMAT));

  const handleCancel = () => {
    setSelectMode(false);
    setSelectedPackage(undefined);
  };

  const handleAdd = () => {
    if (!selectedPackage) {
      return;
    }
    onAdd(
      selectedPackage.days.flatMap((d) =>
        d.products.map((p) => ({ id: p.id, daysShift: d.dayNumber - 1, options: p.options, optional: p.optional })),
      ),
      startDate,
      selectedPackage.tags ?? [],
    );
    setSelectMode(false);
  };

  if (selectMode) {
    return (
      <Stack direction="row" spacing={1}>
        <PackageSelect packageId={selectedPackage?.id.id} fullWidth size="small" onChange={setSelectedPackage} />
        <DatePicker fullWidth size="small" label="Data rozpoczęcia" value={startDate} onChange={setStartDate} />
        <IconButton aria-label="anuluj" onClick={handleCancel}>
          <CancelIcon />
        </IconButton>
        <IconButton aria-label="potwierdź" disabled={!selectedPackage} onClick={handleAdd}>
          <CheckIcon />
        </IconButton>
      </Stack>
    );
  }

  return (
    <Button disabled={disabled} onClick={() => setSelectMode(true)}>
      Dodaj z pakietu
    </Button>
  );
};

export default AddPackageProducts;
